import { FC } from 'react'
import { IPartscareItem } from '../../model/IOrder'

// --
// -- Shield-and-cog mark. Rendered in brand blue when the part can be covered and
// -- in grey when it cannot, so eligibility reads at a glance without the copy.
// --
const PartscareShield: FC<{ colour: string }> = ({ colour }) => (
  <svg
    width='50'
    height='50'
    viewBox='0 0 50 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    className='shrink-0'
  >
    <path
      d='M41.7117 27.1068C41.7117 37.5234 34.4201 42.7318 25.7534 45.7526C25.2996 45.9064 24.8066 45.899 24.3576 45.7318C15.6701 42.7318 8.37842 37.5234 8.37842 27.1068V12.5234C8.37842 11.9709 8.59791 11.441 8.98861 11.0503C9.37931 10.6596 9.90922 10.4401 10.4618 10.4401C14.6284 10.4401 19.8368 7.94011 23.4617 4.77345C23.9031 4.39636 24.4646 4.18918 25.0451 4.18918C25.6256 4.18918 26.1871 4.39636 26.6284 4.77345C30.2743 7.96095 35.4617 10.4401 39.6284 10.4401C40.1809 10.4401 40.7109 10.6596 41.1016 11.0503C41.4923 11.441 41.7117 11.9709 41.7117 12.5234V27.1068Z'
      stroke={colour}
      strokeWidth='4.16667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.2439 15.9323V18.7748C15.2439 18.9059 15.1375 19.0112 15.0075 19.0112H13.6372C13.5072 19.0112 13.4008 18.9048 13.4008 18.7748L13.4019 15.9667H11.979V23.7905H13.4019V20.9823C13.4019 20.8512 13.5083 20.7459 13.6383 20.7459H15.0085C15.1386 20.7459 15.245 20.8523 15.245 20.9823V23.8678L18.543 25.1875C18.5742 25.2004 18.6011 25.2186 18.6247 25.2434L19.8477 26.5104H25.7487C25.7508 26.504 25.7562 26.4964 25.7605 26.49L25.1082 25.7033C25.0286 25.6087 25.0362 25.4712 25.1221 25.3852L26.5955 23.9097C26.6826 23.8237 26.8223 23.8173 26.9158 23.8947L27.7003 24.5481C28.3387 24.1386 29.034 23.8517 29.7712 23.6905L29.8647 22.6728C29.8765 22.5513 29.9775 22.4578 30.1011 22.4578H32.186C32.3085 22.4578 32.4127 22.5513 32.4224 22.6728L32.5159 23.6905C32.8071 23.7539 33.0908 23.8377 33.3681 23.9409V16.2365H30.4406V17.0833C30.4406 17.2144 30.3342 17.3198 30.202 17.3198H28.7426C28.6126 17.3198 28.5062 17.2134 28.5062 17.0833V16.1623L27.1532 15.6486C27.1005 15.6282 27.0543 15.5874 27.0285 15.5358L25.8894 13.3166L18.7707 13.3177L17.1404 15.567C17.1018 15.6175 17.0469 15.6519 16.9835 15.6626L15.2439 15.9323ZM30.0336 24.1181C30.14 24.0988 30.2163 24.0128 30.226 23.9075L30.3173 22.9295H31.9712L32.0604 23.9075C32.0722 24.0128 32.1496 24.0988 32.2528 24.1181C33.0631 24.2718 33.7863 24.5781 34.4677 25.037C34.5569 25.0961 34.6719 25.0907 34.7546 25.023L35.508 24.3954L36.6783 25.5657L36.0529 26.3212C35.9852 26.4029 35.9787 26.5189 36.0389 26.606C36.4967 27.2787 36.8073 28.0246 36.9588 28.822C36.9782 28.9252 37.062 29.0036 37.1684 29.0133L38.1463 29.1036V30.7585L37.1684 30.8499C37.0652 30.8596 36.9782 30.9369 36.9588 31.0412C36.8073 31.8386 36.4967 32.5844 36.0389 33.2582C35.9787 33.3453 35.9862 33.4613 36.0529 33.5419L36.6783 34.2974L35.508 35.4677L34.7546 34.8402C34.673 34.7735 34.5569 34.7671 34.4677 34.8273C33.796 35.2851 33.0491 35.5935 32.2528 35.7461C32.1496 35.7654 32.0722 35.8514 32.0604 35.9567L31.9712 36.9347H30.3173L30.226 35.9578C30.2163 35.8525 30.1389 35.7665 30.0336 35.7461C29.2362 35.5946 28.4925 35.2861 27.8187 34.8273C27.7316 34.7671 27.6166 34.7735 27.535 34.8402L26.7795 35.4677L25.6092 34.2974L26.2379 33.5419C26.3056 33.4613 26.3099 33.3453 26.2497 33.2582C25.7919 32.5855 25.4845 31.8386 25.3319 31.0412C25.3126 30.938 25.2255 30.8596 25.1202 30.8499L24.1455 30.7596V29.1046L25.1202 29.0144C25.2266 29.0047 25.3126 28.9262 25.3319 28.8231C25.4835 28.0257 25.7919 27.2798 26.2497 26.6071C26.3099 26.52 26.3056 26.404 26.2379 26.3223L25.6092 25.5668L26.7795 24.3965L27.535 25.0241C27.6167 25.0907 27.7327 25.0971 27.8187 25.038C28.4936 24.5791 29.2372 24.2697 30.0336 24.1181ZM31.1437 26.3567C33.1158 26.3567 34.7192 27.9601 34.7192 29.931C34.7192 31.9019 33.1157 33.5053 31.1437 33.5053C29.1739 33.5053 27.5705 31.9019 27.5705 29.931C27.5705 27.9601 29.175 26.3567 31.1437 26.3567ZM19.1558 17.4798H25.6791C25.9897 17.4798 25.9897 17.9537 25.6791 17.9537H19.1558C18.8452 17.9537 18.8452 17.4798 19.1558 17.4798ZM19.1558 19.8827H25.6791C25.9897 19.8827 25.9897 20.3567 25.6791 20.3567H19.1558C18.8452 20.3567 18.8452 19.8827 19.1558 19.8827ZM19.1558 22.2857H25.6791C25.9897 22.2857 25.9897 22.7597 25.6791 22.7597H19.1558C18.8452 22.7597 18.8452 22.2857 19.1558 22.2857Z'
      fill={colour}
    />
  </svg>
)

const ELIGIBLE_COLOUR = '#2186CE'
const INELIGIBLE_COLOUR = '#9CA3AF'

const money = (amount?: number | null, currency?: string | null): string =>
  amount == null
    ? '-'
    : new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: (currency || 'usd').toUpperCase(),
      }).format(amount)

const expiryDate = (iso?: string | null): string => {
  if (!iso) return ''
  const parsed = new Date(iso)
  if (Number.isNaN(parsed.getTime())) return ''
  return parsed.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
}

const Title: FC = () => <div className='font-bold'>PartsCare&trade; Warranty</div>

// --
// -- Every state stops click propagation: the product card is itself clickable in
// -- the order list, and enrolling should not also re-select the part.
// --
const PartscareBadge: FC<{ partscare?: IPartscareItem | null }> = ({ partscare }) => {
  // Nothing known about this part (PartsCare misconfigured, or an older payload):
  // show nothing rather than guess at eligibility.
  if (!partscare) return null

  const canEnrol = partscare.eligible && !partscare.offerExpired && !!partscare.offerUrl

  // -- Already covered --------------------------------------------------------
  if (partscare.subscribed)
    return (
      <div
        onClick={(e) => e.stopPropagation()}
        className='flex gap-3 pt-3 border-t sm:pt-0 sm:border-t-0 sm:border-l sm:pl-4 border-gray-200 sm:w-[290px] sm:shrink-0'
      >
        <PartscareShield colour={ELIGIBLE_COLOUR} />
        <div className='flex flex-col gap-1 grow'>
          <Title />
          <div className='text-sm text-gray-700'>
            You are covered
            {partscare.monthlyAmount != null
              ? ` at ${money(partscare.monthlyAmount, partscare.currency)}/mo`
              : ''}
            .
          </div>
          {partscare.offerUrl ? (
            <a
              href={partscare.offerUrl}
              className='mt-1 inline-block text-center border-[1px] font-bold transition duration-300 py-2 px-4 rounded-xl tracking-wide bg-gradient-to-b from-[#ebebeb] to-[#e1e1e1] text-black shadow-sm hover:from-[#e1e1e1] hover:to-[#ebebeb] hover:shadow-md'
            >
              Manage MY subscription
            </a>
          ) : null}
        </div>
      </div>
    )

  // -- Not eligible (or the offer window has closed) --------------------------
  if (!canEnrol)
    return (
      <div
        onClick={(e) => e.stopPropagation()}
        className='flex gap-3 pt-3 border-t sm:pt-0 sm:border-t-0 sm:border-l sm:pl-4 border-gray-200 sm:w-[290px] sm:shrink-0'
      >
        <PartscareShield colour={INELIGIBLE_COLOUR} />
        <div className='flex flex-col gap-1'>
          <Title />
          <div className='text-sm text-gray-500'>
            {partscare.eligible && partscare.offerExpired ? (
              <>
                The <strong>PartsCare&trade;</strong> offer for this purchase has expired.
              </>
            ) : (
              <>
                Purchase is not eligible for <strong>PartsCare&trade;</strong>.
              </>
            )}
          </div>
        </div>
      </div>
    )

  // -- Eligible ---------------------------------------------------------------
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className='flex gap-3 pt-3 border-t sm:pt-0 sm:border-t-0 sm:border-l sm:pl-4 border-gray-200 sm:w-[290px] sm:shrink-0'
    >
      <PartscareShield colour={ELIGIBLE_COLOUR} />
      <div className='flex flex-col gap-1 grow'>
        <Title />
        <div className='text-sm text-gray-700'>
          This purchase is eligible!{' '}
          {partscare.partscareWarrantyUrl ? (
            <a
              href={partscare.partscareWarrantyUrl}
              target='_blank'
              rel='noreferrer'
              className='text-[#2186CE] underline hover:no-underline'
            >
              Learn More
            </a>
          ) : null}
          <br />
          {partscare.coverageYears} Year Protection Plan -{' '}
          {money(partscare.monthlyAmount, partscare.currency)}/mo
        </div>
        <a
          href={partscare.offerUrl as string}
          className='mt-1 inline-block text-center border-[1px] font-bold transition duration-300 py-2 px-4 rounded-xl tracking-wide text-white shadow-sm bg-gradient-to-b from-[#80B742] to-[#5C8D3B] hover:from-[#5C8D3B] hover:to-[#80B742] hover:shadow-lg'
        >
          Enroll in PartsCare&trade;
        </a>
        {partscare.offerExpiresAt ? (
          <div className='text-xs text-gray-500'>
            Offer expires after {expiryDate(partscare.offerExpiresAt)}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default PartscareBadge
